require("@rails/ujs").start()
global.$ = require("jquery")

import '@claviska/jquery-minicolors'
import '@claviska/jquery-minicolors/jquery.minicolors.css'

import 'bootstrap'
import '../scss/backend.scss'

import '../shared/detect_change'
import '../shared/utils'

$(function(){
  $('.js-colorpicker').minicolors({ theme: 'bootstrap' })
})

const images = require.context('../images', true)